import React from "react";
import Navigation from "../Navigation"

function Header() {
    return (
        <div className="Header">
            <Navigation/>
        </div>
    );
}

export default Header;